<div class="loren-asset-details-delete-dialog">
  <h3 class="loren-asset-details-delete-dialog-title">
    {{ "operations.delete" | transloco }} {{ data.assetName }}
  </h3>
  <p class="loren-asset-details-delete-dialog-helptext">
    {{ "asset.delete_asset_confirmation_title" | transloco }}
  </p>
  <mat-dialog-actions class="loren-asset-details-delete-dialog-actions">
    <button matButton="filled" class="btn-secondary" (click)="onCancel()">
      {{ "asset_details.cancel" | transloco }}
    </button>
    <button matButton="filled" class="btn-error" [mat-dialog-close]="true">
      {{ "asset_details.delete" | transloco }}
    </button>
  </mat-dialog-actions>
</div>
